'use client'

import { Loader } from "@googlemaps/js-api-loader"
import { MarkerClusterer } from "@googlemaps/markerclusterer"
import { useEffect, useRef } from "react"
import dynamic from 'next/dynamic'
import imgMarker from '@/assets/img/map/marker.png'
import imgMarker1 from '@/assets/img/map/marker-1.png'
import imgMarker2 from '@/assets/img/map/marker-2.png'
import imgMarker3 from '@/assets/img/map/marker-3.png'
import imgMarker4 from '@/assets/img/map/marker-4.png'
import imgMarker5 from '@/assets/img/map/marker-5.png'
import imgMarker6 from '@/assets/img/map/marker-6.png'
import imgMarker7 from '@/assets/img/map/marker-7.png'
import imgMarker8 from '@/assets/img/map/marker-8.png'
import imgMarker9 from '@/assets/img/map/marker-9.png'
import imgMarker10 from '@/assets/img/map/marker-10.png'
import { useRouter } from "next/navigation"

type Point = {
    latitude: number,
    longitude: number
}

type Marker = {
    position: Point,
    title: string,
    type: string,
    infowindow?: {
        content: string
        target?: string
    },
    object?: Searchable
}


type MapProps = {
    center?: Point,
    markers?: Marker[]
    boundaries?: {
        north: number,
        east: number,
        south: number,
        west: number
    },
    clustering?: boolean,
    setMap?: Function,    
    setMappedMarkers?: Function,
    setActiveObject?: Function
}

export default function Map({
    center,
    markers = [],
    boundaries,
    clustering = false,
    setMap = (map: google.maps.Map) => {},
    setMappedMarkers = (markers: any[]) => {},
    setActiveObject = (object: Searchable) => {}
}: MapProps) {

    const router = useRouter()

    const loader = new Loader({
        apiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
        version: "weekly",
    });

    const ref = useRef<HTMLDivElement>(null)
    const refMap = useRef<google.maps.Map>(null)
    const refMarkers = useRef<google.maps.marker.AdvancedMarkerElement[]>([])
    const refInfowindows = useRef<google.maps.InfoWindow[]>([])
    const refInfowindow = useRef<google.maps.InfoWindow>()
    const refMarkerClusterer = useRef<MarkerClusterer>(null)
    const refTarget = useRef<string>(null)

    function createZoomInControl() {
        const controlButtonin = document.createElement("button");
        // Set CSS for the control.
        controlButtonin.style.cursor = "pointer";
        controlButtonin.innerHTML = "<i class='fi fi-bs-plus'></i>";
        controlButtonin.title = "Zoom avant";
        controlButtonin.type = "button";
        controlButtonin.className = "zoomin";
        controlButtonin.addEventListener("click", () => {
            refMap.current.setZoom(refMap.current.getZoom() + 1);
        });

        return controlButtonin;
    }
    function createZoomOutControl() {
        const controlButtonout = document.createElement("button");
        // Set CSS for the control.
        controlButtonout.style.cursor = "pointer";
        controlButtonout.innerHTML = "<i class='fi fi-bs-minus'></i>";
        controlButtonout.title = "Zoom arrière";
        controlButtonout.type = "button";
        controlButtonout.className = "zoomout";
        controlButtonout.addEventListener("click", () => {
            refMap.current.setZoom(refMap.current.getZoom() - 1);
        });

        return controlButtonout;
    }

    async function initMarkers(markers) {
        const { AdvancedMarkerElement, PinElement } = await loader.importLibrary('marker')

        let mappedMarkers = []

        markers.map((marker: Marker, indexMarker: number) => {

            const numberedIcons = [
                imgMarker1,
                imgMarker2,
                imgMarker3,
                imgMarker4,
                imgMarker5,
                imgMarker6,
                imgMarker7,
                imgMarker8,
                imgMarker9,
                imgMarker10
            ]

            const iconImage = document.createElement("img");
            iconImage.src = marker.type === 'number' ? numberedIcons[indexMarker].src : imgMarker.src
            iconImage.width = 40

            const gmMarker = new AdvancedMarkerElement({
                position: new google.maps.LatLng(marker.position.latitude, marker.position.longitude),
                map: refMap.current,
                content: iconImage,
                title: marker.title,                
                //...marker.infowindow && {gmpClickable: true}
            })

            if (marker.infowindow) {
                /*const infowindow = new InfoWindow({
                    content: marker.infowindow,
                    ariaLabel: "Uluru",
                    position: gmMarker.position
                });*/

                gmMarker.addListener('click', (e) => {
                    /*refInfowindows.current.map((infowindow) => {
                        infowindow.close()
                    })
                    infowindow.open(refMap.current)*/
                    refInfowindow.current.close()
                    refInfowindow.current.setContent(marker.infowindow.content)
                    refInfowindow.current.setOptions({
                        //pixelOffset: new google.maps.Size(-30, 0)
                    })                    
                    refInfowindow.current.open(refMap.current, gmMarker)
                    refTarget.current = marker.infowindow.target       
                    setActiveObject(marker.object)             
                })

                /*refInfowindows.current = [
                    ...refInfowindows.current,
                    infowindow
                ]*/
            }

            mappedMarkers = [
                ...mappedMarkers, {
                    marker,
                    gmMarker
                }
            ]

            refMarkers.current = [
                ...refMarkers.current,
                gmMarker
            ]
        });

        if (clustering) {
            refMarkerClusterer.current = new MarkerClusterer({
                map: refMap.current,
                markers: refMarkers.current,
                renderer: {
                    render: function ({ count, position }, stats) {
                        const color = ['#5f9c99', '#1b706a'][count > stats.clusters.markers.mean ? 1 : 0];
                        const svg = window.btoa(`
                            <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
                                <circle cx="120" cy="120" opacity=".8" r="70" />    
                            </svg>`
                        );
                        // create marker using svg icon
                        return new google.maps.Marker({
                            position,
                            icon: {
                                url: `data:image/svg+xml;base64,${svg}`,
                                scaledSize: new google.maps.Size(75, 75),
                            },
                            label: {
                                text: String(count),
                                color: "rgba(255,255,255,0.9)",
                                fontSize: "16px",
                                fontFamily: "Barlow condensed",
                                fontWeight: '700'
                            },
                            // adjust zIndex to be above other markers
                            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                        });
                    },
                }
            })
        }
        setMappedMarkers(mappedMarkers)
    }

    function initBoundaries() {
        if (boundaries) {
            refMap.current.fitBounds(boundaries)
        }
    }

    useEffect(() => {

        async function load() {
            const { Map, InfoWindow } = await loader.importLibrary('maps')
            const { event } = await loader.importLibrary('core')

            refMap.current = new Map(document.getElementById("map"), {
                ...center && { center: { lat: center.latitude, lng: center.longitude } },
                zoom: 12,
                mapId: process.env.NEXT_PUBLIC_GOOGLE_MAPS_MAP_ID,
                mapTypeControl: false,
                zoomControl: false,
                scaleControl: false,
                streetViewControl: false,
                fullscreenControl: false                
            });

            refInfowindow.current = new InfoWindow()
            refInfowindow.current.addListener('domready', (e) => {
                refMap.current.getDiv().querySelector('.gclose')?.addEventListener('click', (e) => {
                    setActiveObject(null)
                    refInfowindow.current.close()
                    e.stopPropagation()
                })
                refMap.current.getDiv().querySelector('.vignette.map-info')?.addEventListener('click', (e) => {
                    router.push(refTarget.current)
                })
            })            

            const zoomOutControlDiv = document.createElement("div");
            // Create the control.
            const zoomOutControl = createZoomOutControl();
            // Append the control to the DIV.
            zoomOutControlDiv.appendChild(zoomOutControl);

            refMap.current.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(
                zoomOutControlDiv
            );

            // Create the DIV to hold the control.
            const zoomInControlDiv = document.createElement("div");
            // Create the control.
            const zoomInControl = createZoomInControl();
            // Append the control to the DIV.
            zoomInControlDiv.appendChild(zoomInControl);

            refMap.current.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(
                zoomInControlDiv
            );

            console.log('map initmap', markers.length)            

            setMap(refMap.current)

            initBoundaries()         
            initMarkers(markers)
        }

        load()

    }, [])

    useEffect(() => {
        console.log('useEffect makers')
        if (refMap.current === null) {
            return
        }
        refMarkers.current.map((marker) => {
            marker.position = null
            marker.map = null
        })
        refMarkers.current = []
        if (refMarkerClusterer.current !== null) {
            refMarkerClusterer.current.clearMarkers()
            refMarkerClusterer.current.setMap(null)
            refMarkerClusterer.current = null
        }
        console.log('initMarkers')
        initMarkers(markers)
    }, [markers])

    return (
        <div ref={ref} />
    )
}